import React, { FC, FormEvent, JSX, KeyboardEvent } from 'react';

export interface FormProps {
    formRef: React.RefObject<HTMLFormElement | null>;
    id?: string;
    classes?: string;
    onSubmit: (event?: FormEvent) => void;
    onEnterPress?: () => void;
    children: JSX.Element | JSX.Element[];
}

export const Form: FC<FormProps> = ({ formRef, id, classes, onSubmit, onEnterPress, children }) => {
    const handleOnKeyDown = (event: KeyboardEvent<HTMLFormElement>) => {
        if (onEnterPress) {
            if (
                event.key === 'Enter' &&
                // prevent Enter key behavior when in a textarea
                (event.target as HTMLElement).tagName !== 'TEXTAREA'
            ) {
                event.preventDefault();
                onEnterPress();
            }
        }
    };

    const submitForm = (e: React.FormEvent) => {
        e.preventDefault();
        onSubmit(e);
    };

    return (
        <form
            ref={formRef || undefined}
            id={id || undefined}
            className={classes}
            onKeyDown={handleOnKeyDown}
            onSubmit={submitForm}
            data-testid="form">
            {children}
        </form>
    );
};
